import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { jobOffer } from 'job/model/job-offer.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { JobOfferOutput } from '../model/job-offer.output';

export interface UpdateJobOfferParams {
	readonly id: string;
	readonly title: string;
	readonly keyPoints: string;
	readonly companyName: string;
	readonly contractType: string;
}

@Injectable({ providedIn: 'root' })
export class UpdateJobOfferApiMutation extends ApiMutation<
	JobOfferOutput,
	UpdateJobOfferParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateJobOffer(
			$companyName: String
			$contractType: String
			$keyPoints: String
			$title: String!
			$id: UUID!
		) {
			updateJobOffer(
				companyName: $companyName
				contractType: $contractType
				keyPoints: $keyPoints
				title: $title
				id: $id
			) {
				...JobOffer
			}
		}
		${jobOffer}
	`;
	method = 'updateJobOffer';
}
